<template>
    <div class="container">
        <video :src="respRandomVideo" autoplay muted loop preload="auto">
        </video>
        <div class="menu-grad"></div>
        <div class="arrow-bottom"></div>
    </div>
</template>

<script>
   export default {
      name: "Apertura",
       computed: {
           respRandomVideo() {
               return this.$store.getters.respRandomVideo;
           }
       }
   }
</script>

<style scoped>
    .container::before {
        position: absolute;
        left: calc(50% - 35px);
        top: calc(50% - 35px);
        height: 70px;
        width: 70px;
        margin: 0px auto;
        animation: rotation 2.5s infinite linear;
        border: 5px solid rgba(255, 255, 255, 0.15);
        border-top: 5px solid rgba(255, 255, 255, 0.8);
        border-radius: 100%;
        content: "";
    }
</style>